import React, { Component } from 'react'
import Img from 'gatsby-image'
import { FormattedMessage } from 'react-intl'

import logoInstagram from '../../images/instagram.png'
import './style.sass'

import Collapsible from '../collapsible'

export default class Footer extends Component {
  state = {
    panels: {
      links: true,
      contatti: true,
    },
  }

  render() {
    const logoImg = this.props.allImages.find(
      edge => edge.node.sizes.src.indexOf('logo-usi') >= 0
    )

    return (
      <footer className="Footer">
        <div className="Footer__Mobile">
          <Collapsible
            id="links"
            isOpened={this.state.panels['links']}
            title={() => (
              <div className="Footer__Collapsible__Title">Links</div>
            )}
            expandedColor="white"
            collapsedColor="white"
          >
            <div className="Footer__Mobile__Collpase__Content">
              <div>
                <a href="https://www.archiviodelmoderno.org/">
                  Archivio del Moderno
                </a>
              </div>
              <div>
                <a href="http://www.arc.usi.ch/it">Accademia di architettura</a>
              </div>

              <a target="_blank" href="https://www.instagram.com/ticino4580/">
                <img className="Footer__Insta" src={logoInstagram} />
              </a>
            </div>
          </Collapsible>
          <Collapsible
            id="contatti"
            isOpened={this.state.panels['contatti']}
            onClick={this.handleCollapsibleClick}
            title={() => (
              <div className="Footer__Collapsible__Title">
                <FormattedMessage id="menu.contatti" />
              </div>
            )}
            expandedColor="white"
            collapsedColor="white"
          >
            <div className="Footer__Mobile__Collpase__Content text-white">
              <div>Telefono: + 41 58 666 55 00</div>
              <div>Mail: archivio.arc@usi.ch</div>
              <div>Via Magazzini Generali 14</div>
              <div>6828 Balerna (Svizzera)</div>

              <Img
                className="mt-2"
                sizes={logoImg.node.sizes}
                style={{ width: '160px' }}
              />
            </div>
          </Collapsible>
        </div>

        <div className="Footer__Desktop wrap-narrower">
          <div className="Footer__Left">
            <div className="Footer__Heading">Links</div>
            <div>
              <a href="https://www.archiviodelmoderno.org/">
                Archivio del Moderno
              </a>
            </div>
            <div>
              <a href="http://www.arc.usi.ch/it">Accademia di architettura</a>
            </div>

            <a target="_blank" href="https://www.instagram.com/ticino4580/">
              <img className="Footer__Insta" src={logoInstagram} />
            </a>
          </div>
          <div className="Footer__Right">
            <div className="Footer__Heading">
              <FormattedMessage id="menu.contatti" />
            </div>

            <div className="text-white">
              <div>Telefono: + 41 58 666 55 00</div>
              <div>Mail: archivio.arc@usi.ch</div>
              <div>Via Magazzini Generali 14</div>
              <div>6828 Balerna (Svizzera)</div>
            </div>

            <Img
              className="mt-2"
              sizes={logoImg.node.sizes}
              style={{ width: '160px' }}
            />
          </div>
        </div>
      </footer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/footer/index.js